import React from "react";
import Loader from "./Loader";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";

const EnergyAssets = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const navigate = useNavigate();

  const {
    data: energyAssetsData = [],
    energyAssetsError,
    energyAssetsIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "energy-assets-home",
    lang: languageType,
  });

  if (energyAssetsError || !energyAssetsData) {
    return <div>Error loading content.</div>;
  }
  if (energyAssetsIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="energy-assets-area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="title-sec">
                <h4>{getText("Energy Assets", "ऊर्जा संपत्तियाँ")}</h4>
              </div>
            </div>
            {energyAssetsData?.map((item, index) => (
              <div className="col-12 col-sm-12 col-md-4 col-lg-4" key={index}>
                <Link to={item.field_path} title={item.title}>
                  <div className="card-sec  wow zoomIn">
                    <div className="img-sec">
                      <img
                        alt={""}
                        src={
                          process.env.REACT_APP_IMAGE_URL +
                          item.field_assets_home_image
                        }
                      />
                    </div>
                    <div className="desc-sec">
                      <div className="title-sec">
                        <h4>
                          <span
                            type="button"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(item.field_path);
                            }}
                          >
                            {item.title}
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default EnergyAssets;
